import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import '@/styles/index.css'
import '@/i18n'
import { AppProviders, createQueryClient } from '@/app/providers'
import { createRouter } from '@/app/router'
import { isChunkLoadError } from '@/pwa/chunk-errors'
import { PwaProvider } from '@/pwa/pwa-provider'
import { installChunkCapture, reportChunkError } from '@/pwa/runtime'

installChunkCapture()

const queryClient = createQueryClient()
const router = createRouter()

// React Router catches failed lazy route chunks itself; surface them to the controlled recovery path.
router.subscribe((state) => {
  for (const error of Object.values(state.errors ?? {})) {
    if (isChunkLoadError(error)) reportChunkError(error)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders client={queryClient}>
      <PwaProvider>
        <RouterProvider router={router} />
      </PwaProvider>
    </AppProviders>
  </StrictMode>,
)
